//react
import React from "react";

//redux
import { connect } from 'react-redux'

//components
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";

//video player
import ReactPlayer from 'react-player'

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import cardStyle from "assets/jss/material-kit-pro-react/components/cardStyle.jsx";


class VideoCard extends React.Component {

    constructor(props) {
        super(props);
    
        this.state = {
            featuredImage: {URL: null},
          };
        
    }
    
    trim(value, maxLength) {
        if(value) {
            if(value.length > maxLength)
                return value.substring(0,maxLength) + "...";
            else
                return value;
        } else return "";
    }

    getVideoURL() {
        if(this.props.lesson.video)
            return this.props.lesson.video.URL;
        else 
            return "";
    }

    render() {

        const { classes } = this.props;

        return (
            <GridItem xs={12} sm={6} md={4} lg={4}>
                <Card>
                    <div style={{backgroundSize: "cover", height:"200px", width:"100%", borderTopRightRadius:"6px", borderTopLeftRadius:"6px"}}>
                        <ReactPlayer url={this.getVideoURL()} onStart={this.videoPlayed} controls={true} width='100%' height='100%' />        
                    </div>
                    <CardBody style={{minHeight: "123px", position:"relative" }}>
                        <h4 className={classes.cardTitle}>
                            {this.props.lesson.Name}
                        </h4>
                    </CardBody>
                </Card>
            </GridItem>
        )
    }
}

const mapStateToProps = state => {
    return state;
}

VideoCard = connect(mapStateToProps)(VideoCard);
export default withStyles(cardStyle)(VideoCard);



// WEBPACK FOOTER //
// ./src/components/VideoCard/VideoCard.jsx